export default __webpack_public_path__ + "static/media/seyi-report_w1024.a162fe3b.jpeg";